import { Routes, RouterModule } from '@angular/router';

import { NoContentComponent } from './no-content.component';

const NOCONTENT_ROUTES: Routes = [
  { path: '', component: NoContentComponent }
];

export const NoContentRoutingModule = RouterModule.forChild(NOCONTENT_ROUTES);
